import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { AppFAQAction } from "../../../redux/Action/CmsPageAction"
import Spinner from "../../../components/Spinner"

const FaqAPP = () => {
    const faqData = useSelector((state: any) => state.FaqGetAppState)
    const dispatch = useDispatch<any>();

    useEffect(() => {
        dispatch(AppFAQAction({ user_type: "Customer" }))
    }, []);

    return (
        <>

            {faqData?.loading ? <Spinner /> : ""}


            <main>
                <div className='container py-5'>
                    <h1 className='title mb-4'>FAQ's</h1>
                    <div className="accordion  accordion-flush" id="accordionExample">
                        {
                            faqData?.data?.data?.length && faqData?.data?.data?.map((item: any, index: any) => {
                                const targetId = `collapseOne${index}`;

                                return (
                                    <>
                                        <div className="accordion-item" key={index}>
                                            <h2 className="accordion-header">
                                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={"#" + targetId} aria-expanded="true" aria-controls="collapseOne">
                                                    {item?.question}
                                                </button>
                                            </h2>
                                            <div id={targetId} className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                    <p>{item?.answer}</p>
                                                </div>
                                            </div>
                                        </div>

                                    </>
                                )
                            })
                        }

                    </div>
                </div>
            </main>
        </>
    )
}

export default FaqAPP